export const workspace = {
  routes: [
    {
      path: "/workspace/library/risk-definition",
      component: () => import("../definition/workspace-library-risk-definition-view"),
    },
    {
      path: "/workspace/library/risk-threat-definition",
      component: () => import("../threat-definition/workspace-library-risk-threat-definition-view"),
    },
    {
      path: "/workspace/library/risk-source",
      component: () => import("../source/workspace-library-risk-source-view"),
    },
    {
      path: "/workspace/library/risk-type",
      component: () => import("../type/workspace-library-risk-type-view"),
    },
    {
      path: "/workspace/library/risk-category",
      component: () => import("../category/workspace-library-risk-category-view"),
    },
    {
      path: "/workspace/library/risk-weakness-definition",
      component: () => import("../weakness-definition/workspace-library-risk-weakness-definition-view"),
    },
    {
      path: "/workspace/library/risk-applied-control",
      component: () => import("../applied-control/workspace-library-risk-applied-control-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/risk-definition",
      component: () => import("../definition/management-library-risk-definition-view"),
    },
    {
      path: "/management/risk-threat-definition",
      component: () => import("../threat-definition/management-library-risk-threat-definition-view"),
    },
    {
      path: "/management/risk-source",
      component: () => import("../source/management-library-risk-source-view"),
    },
    {
      path: "/management/risk-type",
      component: () => import("../type/management-library-risk-type-view"),
    },
    {
      path: "/management/risk-category",
      component: () => import("../category/management-library-risk-category-view"),
    },
    {
      path: "/management/risk-weakness-definition",
      component: () => import("../weakness-definition/management-library-risk-weakness-definition-view"),
    },
    {
      path: "/management/risk-applied-control",
      component: () => import("../applied-control/management-library-risk-applied-control-view"),
    },
  ],
};

export const risk = {
  routes: [
    {
      path: "/risk/dashboard",
      component: () => import("../organization-risk-dashboard"),
      meta: { rules: [] },
    },
    {
      path: "/risk/decision",
      component: () => import("../decision/organization-risk-decision-view"),
      meta: { rules: [] },
    },
    // {
    //   path: "/risk/list",
    //   component: () => import("../organization-risk-list-view"),
    //   meta: { rules: [] },
    // },

    {
      path: "/risk/view",
      component: () => import("../organization-risk-view"),
      meta: { rules: [] },
    },
    {
      path: "/risk/detail/:id",
      component: () => import("../organization-risk-detail"),
      meta: { rules: [] },
    },
    {
      path: "/risks/create",
      component: () => import("../organization-risk-detail"),
      meta: { rules: [] },
    },
  ],
};

// export const organization = {
//   routes: [
//     {
//       path: "/organization/risk",
//       component: () => import("../organization-risk-view"),
//     },
//     {
//       path: "/organization/risk-detail/:id",
//       component: () => import("../organization-risk-detail"),
//     },
//     {
//       path: "/organization/risk/create",
//       component: () => import("../organization-risk-detail"),
//     },
//   ],
// };
